import AuthMailCodeModule from "../comp/auth-mail-code";

export default function AuthMailCode() {

  return (
    <>
      <AuthMailCodeModule />
    </>
  )
}